import { type Dispatch, type SetStateAction, useState } from 'react';
import type { FilterState } from './types';

export const initialFilter: FilterState = {
  client: [],
  payer: null,
  type: null,
  activity: null,
  outlet_or_service_category: null,
  provider: null,
  block: null,
  invoice: null,
};

export function useFilterState(
  initialState?: Partial<FilterState>,
): [filter: FilterState, setFilter: Dispatch<SetStateAction<FilterState>>] {
  return useState<FilterState>({
    ...initialFilter,
    ...initialState,
  });
}
